<div class="callout-{{ color }} {{ side }}">
  <a
    class="text-side"
    [attr.href]="link"
    [ngClass]="{ indicateHover: link || indicateHover }"
    target="_parent"
    [attr.aria-label]="head"
    >
    @if (head || subhead) {
      <div class="text-side-container text">
        <span
          class="head"
          [innerHTML]="head"
          [ngClass]="{ 'small-text': head && head.length > 64 }"
        ></span>
        @if (subhead) {
          <span class="subhead" [innerHTML]="subhead"></span>
        }
        <span class="material-icons">east</span>
      </div>
    } @else {
      <div class="text-side-container custom">
        <ng-content></ng-content>
        @if (link) {
          <span class="material-icons">east</span>
        }
      </div>
    }
  </a>
  <div
    class="image-side"
    [ngStyle]="getImageStyle()"
    [attr.aria-label]="head"
  ></div>
</div>
